var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('SlideIn',{attrs:{"right":"","show":_vm.showDrawer,"route-name":_vm.$router.currentRoute.name}},[(_vm.errors.length > 0)?_c('ErrorDrawer'):_c('router-view',{attrs:{"name":"drawer"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }